import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import max7 from "../../images/elec.png";
import "../../../src/product.css";

const Max7 = () => {
  return (
    <>
      <Header />

      <main className="product-page container text-center">
        {/* Product Hero */}

        <h2 id="title">MAX 7</h2>

        <section className="product-hero">

          <div className="product-image-wrapper">
            <img
              src={max7}
              alt="Horra Max7"
              className="product-image"
            />
          </div>

          <div className="product-info">

            <p>
              The Horra Max7 is a 100% electric, three-wheeled vehicle
              assembled in Ethiopia by Horra Trading. It is designed to reduce
              fuel dependence and promote eco-friendly urban transport.
            </p>

          </div>
        </section>

        {/* Specifications */}

        <section className="product-specifications">

          <div className="section-heading">
            <span>TECHNICAL DETAILS</span>
            <h2>Specifications</h2>
          </div>

          <div className="spec-grid">

            <div className="spec-card">
              <span>Power Type</span>
              <strong>100% Electric</strong>
            </div>

            <div className="spec-card">
              <span>Vehicle Type</span>
              <strong>Three-Wheeled Vehicle</strong>
            </div>

            <div className="spec-card">
              <span>Passenger Capacity</span>
              <strong>1 Driver + 6 Passengers</strong>
            </div>

            <div className="spec-card">
              <span>Battery Range</span>
              <strong>120 - 160 km</strong>
            </div>

            <div className="spec-card">
              <span>Charging Time</span>
              <strong>3 - 5 Hours</strong>
            </div>

            <div className="spec-card">
              <span>Maximum Load</span>
              <strong>700 kg</strong>
            </div>

            <div className="spec-card">
              <span>Maximum Incline</span>
              <strong>25%</strong>
            </div>

            <div className="spec-card">
              <span>Assembly</span>
              <strong>Ethiopia</strong>
            </div>

          </div>
        </section>

      </main>

      <Footer />
    </>
  );
};

export default Max7;